<template>
  <p class="min-h-[48px] hyphens-auto" :class="configData.Classes">
    {{ configData.Text }}
  </p>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Text: string;
    Classes?: string;
  };
}

defineProps<Props>();
</script>

<style scoped></style>
